export default __webpack_public_path__ + "fed20fa5024a84d829f8c366d599d641.png";